import React, { forwardRef } from 'react';
import { ToggleButtonProvider } from '../ToggleButtonProvider';
import { css, cx } from '@emotion/css';
const styles = css `
  display: flex;

  button {
    border-radius: 0;
  }

  button:first-of-type {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  button:last-of-type {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;
function ToggleButtonGroupInner(props, ref) {
    const { value, onChange, children, className: userClassName, testId, ...rest } = props;
    const className = cx(styles, userClassName, 'ds-toggle-button-group');
    return (React.createElement(ToggleButtonProvider, { value: value, onChange: onChange },
        React.createElement("div", { ref: ref, className: className, role: "group", "data-testid": testId, ...rest }, children)));
}
ToggleButtonGroupInner.displayName = 'ToggleButtonGroup';
export const ToggleButtonGroup = forwardRef(ToggleButtonGroupInner);
